import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, Fragment} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { Menu_Food_CreateInventoryItemModal } from './Modal_EnterMenuItem_Food';
import { Menu_Drink_CreateInventoryItemModal } from './Modal_EnterMenuItem_Drinks';
import { Cart } from './Cart';


export function MenuItem_Add (props){

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showCreateMenuFoodModal, setShowCreateMenuFoodModal] = useState(false);
    let [showCreateMenuDrinksModal, setShowCreateMenuDrinksModal] = useState(false);

    let [showQuantityButton_Food, setShowQuantityButton_Food] = useState(false);
    let [showQuantityButton_Drink, setShowQuantityButton_Drink] = useState(false);

    let [viewInventoryItemMainDetailsData_Food, setViewInventoryItemMainDetailsData_Food] = useState([]);
    let [viewInventoryItemMainDetailsData_Drink, setViewInventoryItemMainDetailsData_Drink] = useState([]);

    let [itemID, setItemID] = useState(null);
    let [productID, setProductID] = useState(null);

    const [cartModal, setCartModal] = useState(false);

    function onSubmitNewDateHandler(e)
    {

        /*let formData = new FormData();
        formData.append('Tracker', '74112_U_OUT');
        formData.append('user', acctID);



        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_U_OUT',
                user: acctID,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
    
            
        })
        .catch(error => {
            console.error(error);
        })

    }

    function getDataItemMain(event) {

        let category = event;
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: category,
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
    
            let rows = res.toString().split('~~~');
    
            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

    
                if(category == "74401_restaurant_retrieveMenu_food")
                {
                    setViewInventoryItemMainDetailsData_Food((prevViewInventoryItemMainDetailsData) => {
                        return prevViewInventoryItemMainDetailsData.concat({
                            productID: cols[0],
                            item_id_list: cols[1],
                            productType: cols[2],
                            productName: cols[3],
                            productPartNum: cols[4],
                            productPhoneNumber: cols[5],
                            productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                            productSalePrice: parseFloat(cols[7]).toFixed(2),
                            productPic1: cols[8],
                            productPic2: cols[9],
                            productPic3: cols[10],
                            productPic4: cols[11],
                            productDateCreated: cols[12],
                            productAddedBy: cols[13],
                            productIsActivated: cols[14],
                            itemQtyInStock: cols[15],

                        })
                    });
                }
                else if(category == "74401_restaurant_retrieveMenu_drinks")
                {
                    setViewInventoryItemMainDetailsData_Drink((prevViewInventoryItemMainDetailsData) => {
                        return prevViewInventoryItemMainDetailsData.concat({
                            productID: cols[0],
                            item_id_list: cols[1],
                            productType: cols[2],
                            productName: cols[3],
                            productPartNum: cols[4],
                            productPhoneNumber: cols[5],
                            productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                            productSalePrice: parseFloat(cols[7]).toFixed(2),
                            productPic1: cols[8],
                            productPic2: cols[9],
                            productPic3: cols[10],
                            productPic4: cols[11],
                            productDateCreated: cols[12],
                            productAddedBy: cols[13],
                            productIsActivated: cols[14],
                            itemQtyInStock: cols[15],

                        })
                    });
                }
    
            } 
        })
    }

    function increaseQuantity()
    {
        document.getElementById("setQuantity").stepUp();
    }
    function decreaseQuantity()
    {
        document.getElementById("setQuantity").stepDown();
    }

    function addMenuItem_ToInvoice(event)
    {

        //alert('Inside Add Menu Item');
        //alert(event[4]);

        let formData = new FormData();
        let Tracker = '';

        //let totalRooms = [...checkInRoomID_multiple, checkInRoomID];
    

            //formData.append('Tracker', 74706);
            //formData.append('user', acctID);            

            if(props.data.status == "order")
            {
                if(event[4] == "Food_Main")
                {
                    //alert('Inside Add FOOD Item');

                    formData.append('Tracker', '74402_R_Food_order');
                    Tracker = '74402_R_Food_order';
                }
                else if(event[4] == "Drink")
                {
                    //alert('Inside Add DRINK Item');

                    formData.append('Tracker', '74402_R_Drink_order');
                    Tracker = '74402_R_Drink_order';

                }

            }
            else
            {
                if(event[4] == "Food_Main")
                {
                    //alert('Inside Add FOOD Item');

                    formData.append('Tracker', '74402_R_Food');
                    Tracker = '74402_R_Food';
                }
                else if(event[4] == "Drink")
                {
                    //alert('Inside Add DRINK Item');

                    formData.append('Tracker', '74402_R_Drink');
                    Tracker = '74402_R_Drink';

                }
            }
            /*formData.append('user', acctID);
            formData.append('xInvoiceID', props.data.invoiceID);
            formData.append('xCheckInRoomID', props.data.roomID);
            formData.append('xQuanityToAdd', document.getElementById('setQuantity').value);
            formData.append('menu_xInventoryItemName', event[1]);
            formData.append('menu_xInventoryItemCostPerUnit', event[2]);
            formData.append('xExtendedSalePrice', (event[2]*document.getElementById('setQuantity').value));
            formData.append('menu_xInventoryVendorName', event[3]);
            formData.append('xCustomerInvoiceID', props.data.customerInvoiceID);
            formData.append('menu_xInventoryproductID', event[0]);


            const requestOptions = {
                encType: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }*/


            //let items = [];
            //items = JSON.parse(event[0]);

            //let itemID = items?.[0]?.id;

            //alert(itemID);
            //alert(JSON.parse(event[0])?.[0]?.id);


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                //body: JSON.stringify({formData})
                body: JSON.stringify({
                    Tracker: Tracker,
                    user: acctID,
                    fmc_schema: schema,
                    xInvoiceID: props.data.invoiceID,
                    xCheckInRoomID: props.data.roomID,
                    xQuanityToAdd: document.getElementById('setQuantity').value,
                    menu_xInventoryItemName:  event[1],
                    menu_xInventoryItemCostPerUnit:  event[2],
                    xExtendedSalePrice: (event[2]*document.getElementById('setQuantity').value),
                    menu_xInventoryVendorName: event[3],
                    xCustomerInvoiceID: props.data.customerInvoiceID,
                    menu_xInventoryItemID: JSON.parse(event[0])?.[0]?.id,
                    xProductID: event[5],
                    sessionID: sessionID,

                })
            }
        
            //alert('addMenuItem_ToInvoice Before Fetch');
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                alert(res);
        
                props.closeModal_update();
        
            })

    }

    function quantityButton_Food(event) {

        setProductID(event[0]);
        setShowQuantityButton_Food(event[1]);

    }

    function quantityButton_Drink(event) {

        setProductID(event[0]);
        setShowQuantityButton_Drink(event[1]);

    }

    useEffect(() =>  {
        
        //getDataItemMain("74401_R_Food");
        //getDataItemMain("74401_R_Drink");   
        
        getDataItemMain("74401_restaurant_retrieveMenu_food");
        getDataItemMain("74401_restaurant_retrieveMenu_drinks");  

    }, [])
    

        return (
            <Fragment>
                <IonGrid >
                    <IonRow>
                        <IonCol>
                            <h4 > Food </h4>
                        </IonCol>
                    </IonRow>
                        <div id='inventoryItemOverviewGrid' style={{display: 'inline-block'}}>
                                <IonGrid class='gridText'>
                                        <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                {/*<IonCol >Vendor Part Number</IonCol>*/}
                                                {/*<IonCol >Vendor Name</IonCol>*/}
                                                <IonCol >Cost per Unit</IonCol>
                                                <IonCol >Qty InStock</IonCol>
                                                {/*<IonCol >Date Replenished</IonCol>*/}
                                                {/*<IonCol >Added By</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                        </IonRow>
                                        {viewInventoryItemMainDetailsData_Food.map((detailData) =>   {
                                            return (
                                                <IonRow key={detailData.productID}>
                                                    <IonCol >{detailData.productID}</IonCol>
                                                    <IonCol >{detailData.productName}</IonCol>
                                                    {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                                    {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                                    <IonCol >{detailData.productSalePrice}</IonCol>
                                                    <IonCol >{detailData.itemQtyInStock}</IonCol>
                                                    {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                                    {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                    <IonCol >
                                                        {showQuantityButton_Food == false  && <IonButton  onClick={() => quantityButton_Food([detailData.productID, true])} > Add </IonButton>}
                                                        {showQuantityButton_Food == true && productID == detailData.productID  && <input type='number' id='setQuantity' value='1' min='1'></input>}
                                                        {showQuantityButton_Food == true && productID == detailData.productID  && <IonButton onClick={() => increaseQuantity(true)}>+</IonButton>}
                                                        {showQuantityButton_Food == true && productID == detailData.productID  && <IonButton onClick={() => decreaseQuantity(true)}>-</IonButton>}
                                                        {showQuantityButton_Food == true && productID == detailData.productID  && <IonButton  onClick={() => addMenuItem_ToInvoice([detailData.item_id_list, detailData.productName, detailData.productSalePrice, detailData.vendorName, "Food_Main", detailData.productID])}> Add to Invoice </IonButton>}
                                                    </IonCol>
                                                </IonRow>
                                            )
                                        }
                                        )}
                                </IonGrid>
                        </div>
                    <IonRow>
                        <IonCol >
                            <h4 > Drinks </h4>
                        </IonCol>
                    </IonRow>
                        <div id='inventoryItemOverviewGrid_Drink' style={{display: 'inline-block'}}>
                                <IonGrid class='gridText'>
                                        <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                {/*<IonCol >Vendor Part Number</IonCol>*/}
                                                {/*<IonCol >Vendor Name</IonCol>*/}
                                                <IonCol >Cost per Unit</IonCol>
                                                <IonCol >Qty InStock</IonCol>
                                                {/*<IonCol >Date Replenished</IonCol>*/}
                                                {/*<IonCol >Added By</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                        </IonRow>
                                        {viewInventoryItemMainDetailsData_Drink.map((detailData) =>   {
                                            return (
                                                <IonRow >
                                                    <IonCol >{detailData.productID}</IonCol>
                                                    <IonCol >{detailData.productName}</IonCol>
                                                    {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                                    {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                                    <IonCol >{detailData.productSalePrice}</IonCol>
                                                    <IonCol >{detailData.itemQtyInStock}</IonCol>
                                                    {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                                    {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                    <IonCol >
                                                        {showQuantityButton_Drink == false  && <IonButton  onClick={() => quantityButton_Drink([detailData.productID, true])} > Add </IonButton>}
                                                        {showQuantityButton_Drink == true && productID == detailData.productID && <input type='number' id='setQuantity' value='1' min='1'></input>}
                                                        {showQuantityButton_Drink == true && productID == detailData.productID && <IonButton onClick={() => increaseQuantity(true)}>+</IonButton>}
                                                        {showQuantityButton_Drink == true && productID == detailData.productID && <IonButton onClick={() => decreaseQuantity(true)}>-</IonButton>}
                                                        {showQuantityButton_Drink == true && productID == detailData.productID && <IonButton  onClick={() => addMenuItem_ToInvoice([detailData.item_id_list, detailData.productName, detailData.productSalePrice, detailData.vendorName, "Drink", detailData.productID])}> Add to Invoice </IonButton>}
                                                    </IonCol>
                                                </IonRow>
                                            )
                                        }
                                        )}
                                </IonGrid>
                        </div>
                </IonGrid>
            </Fragment>
        )
}